import React, { createContext, useCallback, useMemo, useState } from 'react';
import ContactStep from './steps/ContactStep';
import PermissionGroupsStep from './steps/PermissionGroupsStep';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { orderBy } from 'lodash';

const steps = [
  {
    index: 0,
    name: 'contacts',
    label: 'Select Contact',
    component: ContactStep,
    nextButton: true,
    backButton: false
  },
  {
    index: 1,
    name: 'permissiongroups',
    label: 'Select Permission Groups',
    component: PermissionGroupsStep,
    nextButton: false,
    backButton: true
  }
];
const ImportPermissionsContext = createContext({});

export const ImportPermissionsProvider = props => {
  const {
    children,
    isRegular,
    id,
    authorizations,
    hasWriteAuthorizationPermission
  } = props;
  const [activeStep, setActiveStep] = useState(0);
  const [authorizationsToImport, setAuthorizationsToImport] = useState([]);
  const [authorizationsUserChosen, setAuthorizationsUserChosen] = useState([]);
  const [userToCopy, setUserToCopy] = useState(null);

  const funds = useSelector(state => {
    return get(state, 'admin.resources.funds.data', {});
  });
  const finalFunds = useMemo(() => {
    return Object.values(funds);
  }, [funds]);

  const groups = useSelector(state => {
    return get(state, 'admin.resources.groups.data', {});
  });

  const finalGroups = useMemo(() => {
    const groupsArray = Object.values(groups);
    const filteredGroups = groupsArray.filter(item => {
      return item.status === 'ACTIVE' && !item.adminGroup;
    });
    return orderBy(filteredGroups, item => item.name.toLowerCase(), ['ASC']);
  }, [groups]);

  const getActiveStep = useCallback(() => {
    const step = steps[activeStep];
    return <step.component variant="standard" />;
  }, [activeStep]);

  const updateUser = useCallback(user => {
    setUserToCopy(user);
  }, []);

  const onChangeAuthorizationsForImport = useCallback(
    newAuthorizationsToUpdateArray =>
      setAuthorizationsToImport(newAuthorizationsToUpdateArray),
    []
  );

  const value = {
    currentStep: steps[activeStep],
    getActiveStep: getActiveStep(),
    increaseStep: () => setActiveStep(activeStep + 1),
    decreaseStep: () => setActiveStep(activeStep - 1),
    setAuthorizationsUserChosen: authorizationsUser =>
      setAuthorizationsUserChosen(authorizationsUser),
    steps,
    onChangeAuthorizationsForImport: newAuthorizationsToUpdate =>
      onChangeAuthorizationsForImport(newAuthorizationsToUpdate),
    isRegular,
    updateUser,
    userToCopy,
    oldAuthorizations: authorizations,
    newAuthorizationsToImport: authorizationsToImport,
    authorizationsUserChosen,
    groups: finalGroups,
    funds: finalFunds,
    userId: id,
    hasWriteAuthorizationPermission
  };
  return (
    <ImportPermissionsContext.Provider value={value}>
      {children}
    </ImportPermissionsContext.Provider>
  );
};
export default ImportPermissionsContext;
